/**
 * Slider arrows component.
 */
import ArrowLeftIcon from '@components/atoms/icons/arrowLeft';
import ArrowRightIcon from '@components/atoms/icons/arrowRight';
import Focus from '@shared/types/enums/focus';
import SliderArrowsContainer from '@components/atoms/container/sliderArrowsContainer';
import SliderLeftArrowContainer from '@components/atoms/container/sliderLeftArrowContainer';
import SliderRightArrowContainer from '@components/atoms/container/sliderRightArrowContainer';
import { ArrowDirection } from '@shared/types/enums/direction';
import { focusSelector } from '@shared/store/slices/focus.slice';
import { useAppSelector } from '@shared/store/hooks';

/**
 * Constants
 */
const ICON_HEIGHT = 40; // Icon height
const ICON_WIDTH = 25; // Icon width
const OPACITY_DELAY = 200; // Opacity delay

/**
 * Props for the SliderArrows component.
 * @param onClick - The function to call when the arrows are clicked.
 */
export interface SliderArrowsProps {
  onClick: (direction: ArrowDirection) => void;
}

/**
 * Renders the left and right arrows when the sliders area has focus (Focus.SLIDERS).
 * @returns {JSX.Element} The SliderArrows component.
 */
export default function SliderArrows({ onClick }: SliderArrowsProps) {
  const { focus } = useAppSelector(focusSelector);
  return focus === Focus.SLIDERS ? (
    <SliderArrowsContainer delay={OPACITY_DELAY}>
      {/* Left arrow */}
      <SliderLeftArrowContainer onClick={() => onClick(ArrowDirection.LEFT)}>
        <ArrowLeftIcon width={ICON_WIDTH} height={ICON_HEIGHT} />
      </SliderLeftArrowContainer>
      {/* Right arrow */}
      <SliderRightArrowContainer onClick={() => onClick(ArrowDirection.RIGHT)}>
        <ArrowRightIcon width={ICON_WIDTH} height={ICON_HEIGHT} />
      </SliderRightArrowContainer>
    </SliderArrowsContainer>
  ) : null;
}
